/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Resend_Verification_ButtonInputs */

const en_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend Verification Email`)
};

const fr_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renvoyer l'Email de Vérification`)
};

const de_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigungs-E-Mail erneut senden`)
};

const it_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia nuovamente l'email di verifica`)
};

const ru_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторная отправка письма с подтверждением.`)
};

const es_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar correo electrónico de verificación`)
};

const zh_cn2_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新发送验证邮件`)
};

const ja_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`確認メールを再送信`)
};

const hi_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन ईमेल पुनः भेजें`)
};

const pt_pt2_login_resend_verification_button = /** @type {(inputs: Login_Resend_Verification_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar e-mail de verificação`)
};

/**
* | output |
* | --- |
* | "Resend Verification Email" |
*
* @param {Login_Resend_Verification_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_resend_verification_button = /** @type {((inputs?: Login_Resend_Verification_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Resend_Verification_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_resend_verification_button(inputs)
	if (locale === "de") return de_login_resend_verification_button(inputs)
	if (locale === "it") return it_login_resend_verification_button(inputs)
	if (locale === "ru") return ru_login_resend_verification_button(inputs)
	if (locale === "es") return es_login_resend_verification_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_resend_verification_button(inputs)
	if (locale === "ja") return ja_login_resend_verification_button(inputs)
	if (locale === "hi") return hi_login_resend_verification_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_resend_verification_button(inputs)
	return en_login_resend_verification_button(inputs)
});